import { Component, input, output } from '@angular/core';
import { ButtonComponent, ButtonType } from '../../../../components/button/button.component';

@Component({
  selector: 'td-wb-joyride-button',
  templateUrl: './joyride-button.component.html',
  imports: [ButtonComponent]
})
export class JoyrideButtonComponent {
  readonly buttonId = input<string>(undefined);
  readonly buttonType = input<ButtonType>('primary');
  readonly clicked = output<void>();

  onClick(): void {
    this.clicked.emit();
  }
}
